import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import EditLearningItemForm from '../../components/EditLearningItemForm/EditLearningItemForm'
import useRoutes from '../../state/useRoutes'

import styles from './CreateLearningItemPage.module.scss'
import { useLearningItem } from '../../state/entities'

export default React.memo(function CreateLearningItemPage({ kind }: { kind: 'scheduledCourse' | 'onDemandCourse' }) {
  const routes = useRoutes()

  const handleClose = useCallback(() => routes.courses.goto({}), [routes])

  const { learningItem } = useLearningItem(undefined)

  return (
    <article className={styles.CreateLearningItemPage}>
      <EditLearningItemForm onClose={handleClose} kind={kind} learningItem={learningItem} />
    </article>
  )
})

export function CreateLearningItemPageBreadcrumb() {
  const { t } = useTranslation()
  return <span>{t('edit learning.create scheduled course')}</span>
}
